import { Alert, AlertTitle, Box, Link as MuiLink } from '@mui/material'
import { FC } from 'react'
import { useCreatePath, useTranslate } from 'react-admin'
import { Link } from 'react-router-dom'

import { type EventRow, type ScaleWarning, scaleWarnings } from '@/data/source'

import { useMarkerLabel } from './useMarkerLabel'
import { useWarningReason } from './useWarningReason'

const editable = ({ marker }: ScaleWarning): boolean => marker.type !== 'PLACE' && !marker.fromSostrat

export const ScaleWarnings: FC<{ events: EventRow[]; now: number }> = ({ events, now }) => {
  const translate = useTranslate()
  const createPath = useCreatePath()
  const markerLabel = useMarkerLabel()
  const reason = useWarningReason()
  const warnings = scaleWarnings(events, now)
  if (warnings.length === 0) return null

  const title = translate('pages.scales.warnings.title')
  return (
    <Alert severity="warning" variant="outlined" role="region" aria-label={title} data-testid="scale-warnings">
      <AlertTitle>{title}</AlertTitle>
      <Box component="ul" m={0} pl={2.5}>
        {warnings.map((warning, index) => {
          const label = markerLabel(warning.marker)
          return (
            <li key={`${warning.marker.id}-${String(index)}`} data-testid={`scale-warning-${warning.marker.id}`}>
              {editable(warning) ? (
                <MuiLink
                  component={Link}
                  to={createPath({ resource: 'scale_events', type: 'edit', id: warning.marker.id })}
                  fontWeight="bold"
                >
                  {label}
                </MuiLink>
              ) : (
                <Box component="span" fontWeight="bold">
                  {label}
                </Box>
              )}
              {`: ${reason(warning)}`}
            </li>
          )
        })}
      </Box>
    </Alert>
  )
}
